module.exports = __webpack_public_path__ + "img/image (18).0b73e090.jpg";